<template>
    <!-- Componente del icono del menú plegable del header -->
    <div
        class="flex justify-center"
        @click="onClickMenuIcon"
    >
        <img
            width="24"
            height="24"
            v-show="!showMenu"
            class="h-full object-contain cursor-pointer"
            :src="url + '/images/icons/menu_icon.png'"
            alt="Menu"
        >
        <img
            width="24"
            height="24"
            v-show="showMenu"
            class="h-full object-contain cursor-pointer"
            :src="url + '/images/icons/close_menu_icon.png'"
            alt="Cerrar Menu"
        >
    </div>
</template>

<script>
export default {
    data() {
        return {
            url: $('.url').text(),
            webpage: $('.webpage').text(),
            showMenu: false
        }
    },
    methods: {
        onClickMenuIcon() {
            // $('.responsive-menu').css('height', $('main').height())
            this.showMenu = this.showMenu ? false : true
            this.$eventBus.$emit('on-click-menu-icon', this.showMenu)
        }
    }
}
</script>

<style>

</style>